import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SpacesService } from '../../common/components/spaces';
import { Environment, ENVIRONMENT_TOKEN } from '../../core/environment.service';
import { ContextDetailsDto } from '../../common/models/context-details.dto';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContextDetailsService {
    constructor(private http: HttpClient,
                @Inject(ENVIRONMENT_TOKEN) private environment: Environment,
                private spacesService: SpacesService) {
    }

    loadContextDetails(): Observable<ContextDetailsDto> {
        const url = this.spacesService.isPropertySpace() || this.spacesService.isMixedSpace()
            ? `${this.environment.apiBaseUrl}/${this.spacesService.getPropertyUuid()}/properties/${this.spacesService.getPropertyUuid()}/details`
            : `${this.environment.apiBaseUrl}/${this.spacesService.getCompanyUuid()}/company/${this.spacesService.getCompanyUuid()}/details`;

        return this.http.get<ContextDetailsDto>(url);
    }
}
